import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { Loading } from "../Loading";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { useEffect, useState } from "react";
import FormControlLabel from '@mui/material/FormControlLabel';
import './../../index.css';
import Paper from '@mui/material/Paper';
const columns = [
    { field: 'id', headerName: 'ID', width: 90   ,  editable: false,},
 // { field: 'Reserv_Id', headerName: 'Id', width: 20 },
  
 
  {
    field: 'cust_d_date',
    headerName: 'date',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'cust_d_desc',
    headerName: 'Description',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
  {
    field: 'cust_d_mab',
    headerName: 'Amount ',
  //  description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 100,
    editable: false,
    // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  },
 

];

const paginationModel = { page: 0, pageSize: 5 };
export default function Cost_Detail(props) {

    const [checkboxSelection, setCheckboxSelection] = React.useState(true);
  const [disableMultipleRowSelection, setDisableMultipleRowSelection] =    React.useState(false);
    const [loading, setLoading] = useState(false);
  // setData(newData)

const   handleRowClick = (params) => {

   props.allupdate(
   params.row.id,
   params.row.cust_d_date,
    params.row.cust_d_desc, 
   params.row.cust_d_mab,
   )
    };
   if(loading) {
    return "loading ...."
  } 

  return (
    <Paper sx={{ height: 250, width: '100%' }}>
    <DataGrid onRowClick={handleRowClick} 
      rows={props.data}
      columns={columns}
      getRowId={() => crypto.randomUUID()}
      initialState={{ pagination: { paginationModel } }}
      pageSizeOptions={[5, 10]}
    //  checkboxSelection
      sx={{ border: 0 ,fontFamily:'Roboto' , fontWeight:'normal' , fontSize: '14px',backgroundColor:'#F2F2F2'}}
     // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
    
    />
  </Paper>
  );
}